import { GETLEAD, DELETELEAD, UPDATELEAD,GETCHANNELPARTNERCUSTOMERLEAD } from "../actions/types";

const initialState = {};

// eslint-disable-next-line import/no-anonymous-default-export
export default function (state = initialState, action) {
  switch (action.type) {
    case GETLEAD:
      return {
        ...state,
        leadList: action.payload.data,
      };
    case UPDATELEAD:
      return {
        ...state,
        leadUpdateStatus: action.payload.success,
      };

    case DELETELEAD:
      return {
        ...state,
        leadList: state.leadList
          ? state.leadList.filter((item) => item.id !== action.leadId)
          : [],
        leadDeleteStatus: action.payload.success,
      };
       case GETCHANNELPARTNERCUSTOMERLEAD:
      return {
        ...state,
        channelpartnerleadList: action.payload.data,
      };

    default:
      return state;
  }
}
